import { createFileRoute } from '@tanstack/react-router';
import { requirePermission } from '@/features/admin/guard';
import { requireResourcesFeature } from '@/features/resources/guard';
import { ResourceUserDetail } from '@/features/resources/people/resource-user-detail';

export const Route = createFileRoute('/_app/admin/resources/$userId')({
  beforeLoad: async ({ context }) => {
    requirePermission(context.me, 'job_roles.manage');
    await requireResourcesFeature(context.queryClient);
  },
  component: ResourceUserDetailPage,
});

function ResourceUserDetailPage() {
  const { userId } = Route.useParams();
  return <ResourceUserDetail userId={userId} />;
}
